module.exports = __webpack_public_path__ + "img/img03.f746bc78.png";